import { Configuration, LogLevel } from "@azure/msal-browser"

//todo, move variables out of code later... env file? db fetching?
const MS_CLIENT = window.location.hostname.split(".")[0] === "msp"
    ? "bfc8075c-21c7-45f2-bb3e-5d80c2acbafc"
    : "dfda41ec-6b66-48b8-99d4-a16c7b74d12d"


export const MsalConfig: Configuration = {
    auth: {
        clientId: MS_CLIENT,
        authority: "https://login.microsoftonline.com/common",
        redirectUri: `${window.location.origin}/login`,
        postLogoutRedirectUri: window.location.origin,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
    },
    system: {
        allowRedirectInIframe: true,
        windowHashTimeout: 60000,
        iframeHashTimeout: 60000,
        // loggerOptions: {
        //     loggerCallback: (level, message, containsPii) => {
        //         if (containsPii) return;
        //         switch (level) {
        //             case LogLevel.Error:
        //                 console.error(message);
        //                 break;
        //             case LogLevel.Warning:
        //                 console.warn(message);
        //                 break;
        //             case LogLevel.Info:
        //                 console.info(message);
        //                 break;
        //             default:
        //                 console.debug(message);
        //                 break;
        //         }
        //     },
        //     logLevel: LogLevel.Info,
        // }
    },

};

export const loginRequest = {
    scopes: ["User.Read", "email", "profile", "openid"]
};
